<template>
  <div class="receipt-container">
    <Toast />
    <div v-if="loading" class="loading-overlay">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      <p>Memuat data...</p>
    </div>
    <div v-else-if="error" class="error-container">
      <p class="error-message">{{ error }}</p>
      <Button label="Coba Lagi" @click="retryLoadData" />
    </div>
    <div v-else-if="isDataReady">
      <div
        v-for="(items, pageIndex) in paginatedItems"
        :key="pageIndex"
        class="receipt-page"
      >
        <ReceiptHeader
          type="warehouse"
          :data="warehouse"
          :supplierOrigin="supplierOrigin"
        />
        <div class="receipt-content">
          <div class="outgoing-detail" v-if="purchase_order != null">
            <div class="card print" id="printed-element">
              <div class="p-grid">
                <div class="p-col-12 p-m-0">
                  <div class="header-container">
                    <h4 class="title"><b>BON ORDER BARANG</b></h4>
                  </div>
                  <div class="info-row">
                    <div class="left">
                      <p><span>KODE MUTASI</span>: {{ mutationCode }}</p>
                      <p><span>NO BON</span>: {{ docNumber }}</p>
                      <p><span>SUPPLIER</span>: {{ supplierName }}</p>
                    </div>
                    <div class="right">
                      <p><span>TANGGAL BON</span>: {{ docDate }}</p>
                      <p>
                        <span>TANGGAL MUTASI</span>: {{ mutation_date || '-' }}
                      </p>
                    </div>
                  </div>
                  <table class="text-center detail-bon">
                    <thead>
                      <tr style="background-color: grey">
                        <th rowspan="2">NO</th>
                        <th rowspan="2">KODE LABEL</th>
                        <th rowspan="2">NAMA</th>
                        <th rowspan="2">QTY</th>
                        <th rowspan="2">HM (Rp)</th>
                        <th rowspan="2">HARGA JUAL</th>
                        <th :colspan="outlets.length">DISTRIBUSI</th>
                      </tr>
                      <tr
                        style="
                          background-color: grey;
                          font-size: 11px !important;
                        "
                      >
                        <th v-for="(outlet, k) in outlets" :key="k">
                          {{ outlet.alias }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, k) in items"
                        :key="pageIndex * ITEMS_PER_PAGE + k + 1"
                        class="table-data-style"
                      >
                        <td>{{ pageIndex * ITEMS_PER_PAGE + k + 1 }}</td>
                        <td>{{ item.item_code }}</td>
                        <td class="text-left">
                          {{ truncateText(item.item_name, 30) }}
                        </td>
                        <td>{{ item.qty | number }}</td>
                        <td class="text-right">{{ item.price | number }}</td>
                        <td class="text-right"></td>
                        <td
                          v-for="(outlet, k) in outlets"
                          :key="k"
                          class="text-center"
                          style="opacity: 0.4"
                        >
                          {{ outlet.alias }}
                        </td>
                      </tr>
                      <tr
                        v-if="pageIndex + 1 === paginatedItems.length"
                        class="total-row"
                      >
                        <td colspan="3"><b>TOTAL</b></td>
                        <td class="text-center">
                          <b>{{ total_qty | number }}</b>
                        </td>
                        <td class="text-right">
                          <b>{{ total_price | number }}</b>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- FOOTER -->
                  <div
                    class="footer"
                    v-if="pageIndex + 1 === paginatedItems.length"
                  >
                    <div class="footer-left">
                      <h5>(Barang Mutasi Masuk)</h5>
                    </div>
                    <div class="footer-right">
                      <h5>(Bagian Distribusi)</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ReceiptHeader from '@/components/receipt/ReceiptHeader.vue'

export default {
  name: 'PurchasingReceipt',
  components: {
    ReceiptHeader
  },
  data() {
    return {
      // Constants
      ITEMS_PER_PAGE: 25,
      DEFAULT_PHONE: '(061) 6643780',
      DEFAULT_WAREHOUSE_NAME: 'MPOS WAREHOUSE',
      DEFAULT_WAREHOUSE_ADDRESS: 'Jl.Laksana No 68 ABC, Medan',
      PRINT_DELAY: 500,

      // State
      loading: false,
      error: null,
      purchase_order: null,
      outlets: null,
      warehouse: {
        id: null,
        code: '',
        name: '',
        address: '',
        phone: ''
      },
      supplier: null,
      total_price: 0,
      total_qty: 0,
      mutation_date: null,
      isDataReady: false,
      printTimeoutId: null
    }
  },
  computed: {
    ...mapState(['user', 'isAuthenticated']),

    // Safe supplier access
    supplierName() {
      if (this.supplier && this.supplier.length > 0 && this.supplier[0].name) {
        return this.supplier[0].name
      }
      return '-'
    },

    supplierOrigin() {
      if (
        this.supplier &&
        this.supplier.length > 0 &&
        this.supplier[0].origin
      ) {
        return this.supplier[0].origin
      }
      return null
    },

    // Safe route query access
    mutationCode() {
      return this.$route.query.mutation_code || '-'
    },

    docNumber() {
      return this.$route.query.doc_number || '-'
    },

    docDate() {
      return this.$route.query.start_date || '-'
    },

    initId() {
      return this.$route.query.init_id || null
    },

    supplierCode() {
      return this.$route.query.supplier_code || null
    },

    // Paginated items computed property
    paginatedItems() {
      if (!this.purchase_order || this.purchase_order.length === 0) {
        return []
      }
      const pages = []
      for (
        let i = 0;
        i < this.purchase_order.length;
        i += this.ITEMS_PER_PAGE
      ) {
        pages.push(this.purchase_order.slice(i, i + this.ITEMS_PER_PAGE))
      }
      return pages
    }
  },
  async mounted() {
    // Validate route parameters first
    if (!this.validateRouteParams()) {
      return
    }

    this.loading = true
    this.error = null

    try {
      // Wait for user data to be available (with timeout)
      await this.waitForUserData()

      // Fetch warehouse info first (depends on user.warehouse_id)
      await this.getWarehouseInfo()

      // Fetch independent APIs in parallel (after warehouse info is ready)
      await Promise.allSettled([this.getSupplier(), this.getOutlet()])

      // Fetch purchase orders (depends on warehouse)
      await this.getPurchaseOrders()

      // Wait for data to be ready
      this.isDataReady = true

      // Add event listener for afterprint
      window.addEventListener('afterprint', this.handleAfterPrint)

      // Wait for next tick and then print
      this.$nextTick(() => {
        this.triggerPrint()
      })
    } catch (error) {
      console.error('Error in mounted:', error)
      this.error = error.message || 'Gagal memuat data. Silakan coba lagi.'
      this.showToast('error', 'Error', this.error)
    } finally {
      this.loading = false
    }
  },

  beforeDestroy() {
    // Clean up event listener
    window.removeEventListener('afterprint', this.handleAfterPrint)

    // Clear timeout if component unmounts before print
    if (this.printTimeoutId) {
      clearTimeout(this.printTimeoutId)
    }
  },

  methods: {
    // ============================================
    // Lifecycle & Event Handlers
    // ============================================
    handleAfterPrint() {
      // Close the current tab
      //window.close()
    },

    retryLoadData() {
      this.error = null
      this.mounted()
    },

    triggerPrint() {
      // Wait for DOM to be fully rendered
      this.$nextTick(() => {
        // Check if content is ready
        const printElement = document.getElementById('printed-element')
        if (!printElement) {
          console.warn('Print element not found, retrying...')
          this.printTimeoutId = setTimeout(() => this.triggerPrint(), 500)
          return
        }

        // Trigger print
        this.printTimeoutId = setTimeout(() => {
          window.print()
        }, this.PRINT_DELAY)
      })
    },

    // ============================================
    // Validation Methods
    // ============================================
    validateRouteParams() {
      const requiredParams = [
        'init_id',
        'supplier_code',
        'mutation_code',
        'doc_number',
        'start_date'
      ]
      const missingParams = requiredParams.filter(
        param => !this.$route.query[param]
      )

      if (missingParams.length > 0) {
        const errorMsg = `Parameter yang diperlukan tidak ditemukan: ${missingParams.join(
          ', '
        )}`
        this.showToast('error', 'Error', errorMsg)
        this.error = errorMsg
        return false
      }
      return true
    },

    // ============================================
    // Data Fetching Methods
    // ============================================

    async getOutlet() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets`
        )
        if (response.status === 200) {
          this.outlets = response.data.data.outlets || []
        }
      } catch (error) {
        console.error('Error fetching outlets:', error)
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Gagal mengambil data outlet'
        this.showToast('error', 'Error', errorMessage)
        this.outlets = []
      }
    },

    /**
     * Wait for user data to be available in Vuex store
     * @returns {Promise} Resolves when user.warehouse_id is available
     */
    waitForUserData() {
      return new Promise((resolve, reject) => {
        const maxAttempts = 50 // 5 seconds max wait (50 * 100ms)
        let attempts = 0

        const checkUser = () => {
          attempts++

          // Check if user and warehouse_id are available
          if (
            this.user &&
            this.user.warehouse_id !== undefined &&
            this.user.warehouse_id !== null
          ) {
            resolve()
            return
          }

          // If max attempts reached, reject
          if (attempts >= maxAttempts) {
            reject(
              new Error(
                'User data tidak tersedia. Silakan refresh halaman atau login ulang.'
              )
            )
            return
          }

          // Check again after 100ms
          setTimeout(checkUser, 100)
        }

        // Start checking
        checkUser()
      })
    },

    async getWarehouseInfo() {
      // Validate warehouse_id is available before making API call
      if (
        !this.user ||
        this.user.warehouse_id === undefined ||
        this.user.warehouse_id === null
      ) {
        console.warn(
          'warehouse_id is not available, using default warehouse values'
        )
        // Fallback to default values if warehouse_id is not available
        this.warehouse = {
          id: null,
          code: '',
          name: this.DEFAULT_WAREHOUSE_NAME,
          address: this.DEFAULT_WAREHOUSE_ADDRESS,
          phone: this.DEFAULT_PHONE
        }
        return
      }

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/warehouses/${this.user.warehouse_id}`
        )
        if (response.status === 200) {
          const warehouseData = response.data.data
          this.warehouse = {
            id: warehouseData.id,
            code: warehouseData.code,
            name: warehouseData.name,
            address: warehouseData.address || this.DEFAULT_WAREHOUSE_ADDRESS,
            phone: warehouseData.phone || this.DEFAULT_PHONE
          }
        }
      } catch (error) {
        console.error('Error fetching warehouse info:', error)
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Gagal mengambil data gudang'
        this.showToast('error', 'Error', errorMessage)
        // Fallback to default values if API call fails
        this.warehouse = {
          id: null,
          code: '',
          name: this.DEFAULT_WAREHOUSE_NAME,
          address: this.DEFAULT_WAREHOUSE_ADDRESS,
          phone: this.DEFAULT_PHONE
        }
      }
    },

    async getSupplier() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/suppliers?code=${this.supplierCode}`
        )
        if (response.status === 200) {
          this.supplier = response.data.data.suppliers || []
        }
      } catch (error) {
        console.error('Error fetching supplier:', error)
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Gagal mengambil data supplier'
        this.showToast('error', 'Error', errorMessage)
        this.supplier = []
      }
    },

    async getPurchaseOrders() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/purchase-orders/print/bon?init_id=${this.initId}`
        )
        if (response.status === 200) {
          this.purchase_order = response.data.data.purchase_orders || []
          this.total_price = response.data.data.total_price || 0
          if (response.data.data.mutation_date) {
            this.dateFormatter(response.data.data.mutation_date)
          }
          this.getTotalQty()
        }
      } catch (error) {
        console.error('Error fetching purchase orders:', error)
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Gagal mengambil data pembelian'
        this.showToast('error', 'Error', errorMessage)
        this.purchase_order = []
      }
    },

    // ============================================
    // Data Transformation Methods
    // ============================================

    dateFormatter(date) {
      if (!date) return null
      const dateObj = new Date(date)
      if (isNaN(dateObj.getTime())) return null

      const year = dateObj.getFullYear()
      const month = String(dateObj.getMonth() + 1).padStart(2, '0')
      const day = String(dateObj.getDate()).padStart(2, '0')
      this.mutation_date = `${year}-${month}-${day}`
    },

    getTotalQty() {
      if (!this.purchase_order || this.purchase_order.length === 0) {
        this.total_qty = 0
        return
      }
      this.total_qty = this.purchase_order.reduce(
        (sum, order) => sum + (parseInt(order.qty) || 0),
        0
      )
    },

    truncateText(text, length) {
      if (!text) return '-'
      // Remove newline characters
      const cleanedText = text.replace(/[\r\n]+/g, ' ').trim()
      if (cleanedText.length <= length) return cleanedText
      return cleanedText.substring(0, length)
    }
  }
}
</script>

<style scoped lang="scss">
// Loading and Error States
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  p {
    margin-top: 1rem;
    font-size: 1rem;
    color: #495057;
  }
}

.error-container {
  padding: 2rem;
  text-align: center;

  .error-message {
    color: #dc3545;
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }
}

// Receipt Container with Monospace Font
.receipt-container {
  font-family: 'Courier New', Courier, monospace;
  padding: 20px;
  background: #fff;
}

.receipt-page {
  font-family: 'Courier New', Courier, monospace;
  page-break-after: always;
  page-break-inside: avoid;

  &:last-child {
    page-break-after: auto;
  }
}

// Compact Header Styles
:deep(.receipt-header) {
  margin-bottom: 0.25rem;
  padding: 0.25rem 0;
}

:deep(.border-header) {
  margin: 0.25rem 0 0.5rem 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
}

table thead th {
  border: 1px solid #000;
  padding: 8px 6px;
}

.card {
  display: block;
}

.company-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.logo {
  width: 50px;
}

.company-info {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header-title {
  font-size: 15px;
  line-height: 1.2;
  font-weight: bold;
  margin-bottom: 2px;
}

.header-subtitle {
  font-size: 13px;
  line-height: 1.2;
  margin-bottom: 1px;
}

.supplier-info {
  margin-left: auto;
  h1 {
    font-size: 24px;
    margin: 0;
  }
}

.title {
  font-family: 'Courier New', Courier, monospace;
  text-align: center;
  margin: 0 !important;
  padding: 0 !important;
  font-size: 12px;
  line-height: 0.9;
}

// Target h4 specifically to override browser defaults
h4.title {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 16px !important;
  line-height: 0.9 !important;
}

.header-container {
  text-align: center;
  margin: 0 !important;
  padding: 0 !important;
}

.info-row {
  font-family: 'Courier New', Courier, monospace;
  display: flex;
  justify-content: space-between;
  margin: 0px;
}

.left,
.right {
  p {
    margin: 1px 0;
    display: flex;
    font-size: 0.9rem;
    line-height: 1.2;
    span {
      width: 120px;
      font-weight: 500;
    }
  }
}

.border-header {
  border-top: 2px solid #000;
  width: 100%;
  margin: 12px auto;
  justify-content: center;
}

.detail-bon {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Courier New', Courier, monospace;
  font-size: 14px;
  table-layout: fixed; // Fixed table layout for consistent column widths

  th,
  td {
    border: 1px solid #000;
    padding: 4px 4px;
    text-align: center;
    font-size: 14px;
    overflow: hidden;
  }

  th {
    background-color: #f0f0f0;
    font-weight: 600;
    font-size: 14px;
  }

  // Fixed column widths
  th:nth-child(1),
  td:nth-child(1) {
    width: 2rem; // No - reduced from 3rem
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 6rem; // Kode Label
  }

  th:nth-child(3),
  td:nth-child(3) {
    width: 16rem; // Nama - expanded from 12rem
  }

  th:nth-child(4),
  td:nth-child(4) {
    width: 3rem; // Qty - reduced from 4rem
  }

  th:nth-child(5),
  td:nth-child(5) {
    width: 6rem; // HM (Rp)
  }

  th:nth-child(6),
  td:nth-child(6) {
    width: 6rem; // Harga Jual
  }

  .text-left {
    text-align: left;
  }

  .text-right {
    text-align: right;
  }

  .text-center {
    text-align: center;
  }

  .table-data-style {
    &:nth-child(even) {
      background-color: #f8f9fa;
    }
  }

  .total-row {
    font-weight: 600;
    background-color: #f8f9fa;
  }
}

.footer {
  font-family: 'Courier New', Courier, monospace;
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  padding: 0 1rem;

  h5 {
    font-size: 12px;
    margin: 0;
  }
}

@media print {
  .receipt-container {
    font-family: 'Courier New', Courier, monospace !important;
  }

  .receipt-page {
    font-family: 'Courier New', Courier, monospace !important;
  }

  .outgoing-detail {
    margin: 0;
    padding: 0;
  }

  .card,
  .title,
  .header-container,
  .info-row,
  .footer {
    box-shadow: none;
    padding: 0 !important;
  }

  .detail-bon {
    font-family: 'Courier New', Courier, monospace !important;
    font-size: 13px !important;
    table-layout: fixed !important; // Ensure fixed layout in print

    th,
    td {
      padding: 1px auto !important;
      font-size: 12px !important;
      overflow: hidden !important;
    }

    // Maintain fixed column widths in print
    th:nth-child(1),
    td:nth-child(1) {
      width: 2rem !important; // No - reduced from 3rem
    }

    th:nth-child(2),
    td:nth-child(2) {
      width: 6rem !important; // Kode Label
    }

    th:nth-child(3),
    td:nth-child(3) {
      width: 16rem !important; // Nama - expanded from 12rem
    }

    th:nth-child(4),
    td:nth-child(4) {
      width: 3rem !important; // Qty - reduced from 4rem
    }

    th:nth-child(5),
    td:nth-child(5) {
      width: 6rem !important; // HM (Rp)
    }

    th:nth-child(6),
    td:nth-child(6) {
      width: 6rem !important; // Harga Jual
    }

    th {
      background-color: #f0f0f0 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    // Tbody cells with increased font weight in print only
    td {
      font-weight: 510 !important;
    }

    .table-data-style:nth-child(even) {
      background-color: #f8f9fa !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .total-row {
      background-color: #f8f9fa !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }

  .title,
  h4.title {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 16px !important;
    line-height: 0.9 !important;
  }

  .header-container {
    margin: 0 !important;
    padding: 0 !important;
  }

  .title,
  .info-row,
  .footer {
    font-family: 'Courier New', Courier, monospace !important;
  }

  .print {
    padding: 0;
    margin: 0;
    font-size: 12px !important;
    page-break-after: always;
  }

  .print:last-child {
    page-break-after: auto;
  }
}
</style>
